module.exports = __webpack_public_path__ + "static/img/no-notice-img.d48ab9ff.png";